// extracted by mini-css-extract-plugin
module.exports = {"default":"styles-module--default--26Pzi","svg":"styles-module--svg--2rPIn","svgcontainer":"styles-module--svgcontainer--34D09"};